import React from 'react';
import styles from '../styles/ModalLux.module.css';

export default function ModalLux({ open, onClose, children, title }) {
  if (!open) return null;
  return (
    <div className={styles.modalBackdrop} role="presentation" onMouseDown={e => { if (e.target === e.currentTarget) onClose?.(); }}>
      <div className={styles.modalContainer} role="dialog" aria-modal="true" aria-labelledby="modal-lux-title">
        <div className={styles.modalHeader}>
          <h2 id="modal-lux-title" className={styles.modalTitle}>{title}</h2>
          <button className={styles.modalClose} aria-label="Cerrar" onClick={onClose}>✕</button>
        </div>
        <div className={styles.modalBody}>{children}</div>
      </div>
    </div>
  );
}
